module.exports = "https://cdn.hellotech.com/client-assets/garage_doors_tablet_bcec92b3f1843af66451af3493c5c946.png";